import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M7.2 14.8a2 2 0 0 1 2 2"/>
  <circle cx="18.5" cy="8.5" r="3.5"/>
  <circle cx="7.5" cy="16.5" r="5.5"/>
  <circle cx="7.5" cy="4.5" r="2.5"/>
</svg>`;

const Spa = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='spa' svg={svg} {...props} />
  )
);

Spa.displayName = 'SpaIcon';

export default Spa;
